export enum FieldState {
  Default = 'default',
  Success = 'success',
  Invalid = 'invalid',
  Info = 'info'
}

export type DropdownValue = string | number | boolean | Date;

export interface DropdownOption<T = DropdownValue> {
  label: string;
  value: T;
  description?: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string | undefined | null): boolean {
  return EMAIL_PATTERN.test((value ?? '').trim());
}

export function toStringValue(value: string | number | undefined | null): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number' && Number.isNaN(value)) return '';

  return String(value);
}

export enum FieldType {
  Select = 'select',
  Text = 'text',
  Textarea = 'textarea',
  Integer = 'integer',
  Datetime = 'datetime',
  Email = 'email',
  Phone = 'phone',
  Currency = 'currency',
  Boolean = 'boolean',
  Date = 'date',
  Time = 'time'
}
